/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Preview_Pdf_InvalidInputs */

const vi_einvoice_error_preview_pdf_invalid = /** @type {(inputs: Einvoice_Error_Preview_Pdf_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA không trả về file PDF xem trước hợp lệ. Vui lòng thử lại sau.`)
};

/**

* @param {Einvoice_Error_Preview_Pdf_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_preview_pdf_invalid = /** @type {((inputs?: Einvoice_Error_Preview_Pdf_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Preview_Pdf_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_preview_pdf_invalid(inputs)
});